// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gsaj","content":"styles_content__271uK","tableWrap":"styles_tableWrap__31CvB"};